// send-message.service.ts
import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class NotificacaoChangeService {

  attNotificacaoCountEvent = new EventEmitter<any>();

  constructor() { }
}
